import React from "react";
import Header from "../components/Header.js";
import BackButton from "../components/BackButton.js";
import CreateHazardForm from "../components/CreateHazardForm.js";
import {useLocation} from "react-router-dom";

function NewHazardPage(props) {
  const { state } = useLocation();
  return (
    <div className="page" id="newHazardPage">
      <Header title="New Hazard" />
      <BackButton
        navigateUrl={state?.previousPage ? state.previousPage : "/"}
      />

      <CreateHazardForm data={props} actionType="new" />
    </div>
  );
}

export default NewHazardPage;
